import tippy from "tippy.js";
import 'tippy.js/dist/tippy.css';

let callback = (entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const entryTargetId = entry.target.id;
      const sidebarLinks = document.querySelectorAll(
        ".page-user-register-sidebar a"
      );
      sidebarLinks.forEach((item) => item.classList.remove("active"));
      document
        .querySelector(
          ` .page-user-register-sidebar a[href="#${entryTargetId}"]`
        )
        .classList.add("active");
    }
  });
};

let options = {
  rootMargin: "0px",
  threshold: 0.5,
};

let observer = new IntersectionObserver(callback, options);

function createTooltip() {
  const formElements = document.querySelectorAll('[data-tooltip="true"]');

  if (!formElements.length > 0) return;

  formElements.forEach((el) => {
    if (el.querySelector(".js-tooltip")) return;

    let labelElement = null;

    if (el.tagName === "FIELDSET") {
      labelElement = el.querySelector(":scope > legend");
    } else {
      labelElement = el.querySelector(":scope > label");
    }

    const description = el.querySelector(".description");

    if (labelElement && description) {
      const tooltipText = description.innerHTML;
      insertTooltipToElement(labelElement, tooltipText);
    }
  });
}

function insertTooltipToElement(element, tooltipText) {
  const html = `
    <div class="tooltip__icon">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_848_3851)">
    <path d="M9.99935 18.3333C5.39685 18.3333 1.66602 14.6025 1.66602 9.99996C1.66602 5.39746 5.39685 1.66663 9.99935 1.66663C14.6018 1.66663 18.3327 5.39746 18.3327 9.99996C18.3327 14.6025 14.6018 18.3333 9.99935 18.3333ZM9.99935 16.6666C11.7675 16.6666 13.4632 15.9642 14.7134 14.714C15.9636 13.4638 16.666 11.7681 16.666 9.99996C16.666 8.23185 15.9636 6.53616 14.7134 5.28591C13.4632 4.03567 11.7675 3.33329 9.99935 3.33329C8.23124 3.33329 6.53555 4.03567 5.2853 5.28591C4.03506 6.53616 3.33268 8.23185 3.33268 9.99996C3.33268 11.7681 4.03506 13.4638 5.2853 14.714C6.53555 15.9642 8.23124 16.6666 9.99935 16.6666ZM9.16602 5.83329H10.8327V7.49996H9.16602V5.83329ZM9.16602 9.16663H10.8327V14.1666H9.16602V9.16663Z" fill="#28292A"/>
    </g>
    <defs>
    <clipPath id="clip0_848_3851">
    <rect width="20" height="20" fill="white"/>
    </clipPath>
    </defs>
    </svg>
    
    </div>
  `;
  const breakPoint = window.matchMedia("(max-width: 768px)");

  const tooltip = document.createElement("button");
  tooltip.type = "button";
  tooltip.setAttribute("role", "tooltip");
  tooltip.classList.add("js-tooltip");
  tooltip.innerHTML = html;

  if (element) element.after(tooltip);

  const tooltipContent = `
  <div class="tooltip-content">
  ${tooltipText}
  <button type="button" class="close-tooltip" title="Close tooltip" aria-label="Close tooltip">✕</button>
  </div>
  `;

  tippy(tooltip, {
    content: tooltipContent,
    allowHTML: true,
    maxWidth: 350,
    offset: breakPoint.matches ? [0, 5] : [0, 8],
    placement: breakPoint.matches ? "top" : "right",
    arrow: true,
    trigger: "click",
    hideOnClick: true,
    interactive: true,
    onShow(instance) {
      instance.popper.querySelector('.close-tooltip').addEventListener('click', () => {
        instance.hide();
      });
    },
    onHide(instance) {
      instance.popper.querySelector('.close-tooltip').removeEventListener('click', () => {
        instance.hide();
      });
    },
  });
}

function handleToggleCheckboxOptions(selector) {
  const wrapperElement = document.querySelector(
    `${selector} .form-checkboxes`
  );
  const checkboxes = document.querySelectorAll(
    `${selector} .form-checkboxes .js-form-type-checkbox`
  );

  const checkedItems = document.querySelectorAll(`${selector} .form-checkboxes .js-form-type-checkbox input[checked="checked"]`);

  if (checkedItems.length > 0) return;

  if (!checkboxes.length > 0) return;

  const LIMIT = 8;

  if (checkboxes.length > LIMIT) {
    for (let i = 0; i < checkboxes.length; i++) {
      if (i >= LIMIT) {
        checkboxes[i].style.display = "none";
      }
    }

    const btnShowAll = document.createElement("button");
    btnShowAll.type = "button";
    btnShowAll.innerText = `Show all (${checkboxes.length})`;
    btnShowAll.classList.add("button-show-all");
    btnShowAll.setAttribute("role", "button");

    btnShowAll.addEventListener("click", (e) => {
      for (let i = 0; i < checkboxes.length; i++) {
        checkboxes[i].style.display = "block";
      }

      btnShowAll.style.display = "none";
    });

    wrapperElement.appendChild(btnShowAll);
  }
}

function handlePostalAddress() {
  const postalElement = document.querySelector(
    ".js-form-item-field-postal-address-xnal-0-address-autocomplete"
  );
  const manualFields = document.querySelector(
    "#field-postal-address-xnal-0-address-ajax-wrapper"
  );

  if (!postalElement || !manualFields) return;

  const enterManuallyButton = document.createElement("button");
  enterManuallyButton.type = "button";
  enterManuallyButton.innerText = "Enter manually";
  enterManuallyButton.classList.add("btn-enter-manually");
  postalElement.after(enterManuallyButton);

  enterManuallyButton.addEventListener("click", () => {
    manualFields.style.display = "block";
    enterManuallyButton.style.display = "none";
  });
}

function handlePassword(form) {
  const passwordInput = form.querySelector("#edit-pass-pass1");
  const passwordConfirmInput = form.querySelector("#edit-pass-pass2");
  const submitButton = form.querySelector("#edit-submit");

  const passwordErrorEl = document.createElement("div");
  passwordErrorEl.innerText = "Passwords don’t match.";
  passwordErrorEl.classList.add("password-error-message");
  passwordConfirmInput.after(passwordErrorEl);

  const togglePasswordEl = document.createElement("button");
  togglePasswordEl.setAttribute("role", "button");
  togglePasswordEl.setAttribute("type", "button");
  togglePasswordEl.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none">
  <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M1 12C1 12 5 20 12 20C19 20 23 12 23 12" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <circle cx="12" cy="12" r="3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;
  togglePasswordEl.setAttribute("aria-label", "Show password");
  togglePasswordEl.classList.add("toggle-password");

  let clickCount = 0;

  togglePasswordEl.addEventListener("click", () => {
    if (clickCount % 2 == 0) {
      passwordInput.setAttribute("type", "text");
      passwordConfirmInput.setAttribute("type", "text");
      togglePasswordEl.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 28 28" fill="none"><path clip-rule="evenodd" d="M22.6928 1.55018C22.3102 1.32626 21.8209 1.45915 21.6 1.84698L19.1533 6.14375C17.4864 5.36351 15.7609 4.96457 14.0142 4.96457C9.32104 4.96457 4.781 7.84644 1.11993 13.2641L1.10541 13.2854L1.09271 13.3038C0.970762 13.4784 0.967649 13.6837 1.0921 13.8563C3.79364 17.8691 6.97705 20.4972 10.3484 21.6018L8.39935 25.0222C8.1784 25.4101 8.30951 25.906 8.69214 26.1299L9.03857 26.3326C9.4212 26.5565 9.91046 26.4237 10.1314 26.0358L23.332 2.86058C23.553 2.47275 23.4219 1.97684 23.0392 1.75291L22.6928 1.55018ZM18.092 8.00705C16.7353 7.40974 15.3654 7.1186 14.0142 7.1186C10.6042 7.1186 7.07416 8.97311 3.93908 12.9239C3.63812 13.3032 3.63812 13.8561 3.93908 14.2354C6.28912 17.197 8.86102 18.9811 11.438 19.689L12.7855 17.3232C11.2462 16.8322 9.97333 15.4627 9.97333 13.5818C9.97333 11.2026 11.7969 9.27368 14.046 9.27368C15.0842 9.27368 16.0317 9.68468 16.7511 10.3612L18.092 8.00705ZM15.639 12.3137C15.2926 11.7767 14.7231 11.4277 14.046 11.4277C12.9205 11.4277 12 12.3906 12 13.5802C12 14.3664 12.8432 15.2851 13.9024 15.3624L15.639 12.3137Z" fill="#000000" fill-rule="evenodd"/><path d="M14.6873 22.1761C19.1311 21.9148 23.4056 19.0687 26.8864 13.931C26.9593 13.8234 27 13.7121 27 13.5797C27 13.4535 26.965 13.3481 26.8956 13.2455C25.5579 11.2677 24.1025 9.62885 22.5652 8.34557L21.506 10.2052C22.3887 10.9653 23.2531 11.87 24.0894 12.9239C24.3904 13.3032 24.3904 13.8561 24.0894 14.2354C21.5676 17.4135 18.7903 19.2357 16.0254 19.827L14.6873 22.1761Z" fill="#000000"/></svg>`;
    } else {
      passwordInput.setAttribute("type", "password");
      passwordConfirmInput.setAttribute("type", "password");
      togglePasswordEl.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none">
      <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M1 12C1 12 5 20 12 20C19 20 23 12 23 12" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="12" cy="12" r="3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;
    }

    clickCount += 1;
  });

  passwordInput.after(togglePasswordEl);

  //check if passwords match

  passwordConfirmInput.addEventListener("blur", () => {
    if (passwordInput.value !== passwordConfirmInput.value) {
      passwordErrorEl.classList.add("visible");
      passwordConfirmInput.classList.add("error");
      submitButton.disabled = true;
    } else {
      passwordErrorEl.classList.remove("visible");
      passwordConfirmInput.classList.remove("error");
      submitButton.disabled = false;
    }
  });

  const passwordStrengthMeter = document.createElement("div");
  passwordStrengthMeter.classList.add("password-strength-meter");
  passwordStrengthMeter.innerHTML = `
  <div class="password-bars">
  <span class="bar"></span><span class="bar"></span><span class="bar"></span>
  </div>
  <div id="password-status"></div>
  <div id="password-strength-error">Your password is not strong enough, please re-try. Your password must be 12+ characters and include at least one special character e.g. ! @ # and an uppercase letter.</div>
  `;

  passwordInput.after(passwordStrengthMeter);

  const passwordStrengthError = document.querySelector(
    "#password-strength-error"
  );
  const passwordStatus = document.querySelector("#password-status");

  let strength = "";

  // Function to update password strength
  function updatePasswordStrength() {
    var passwordLength = passwordInput.value.length;
    var hasUpperCase = /[A-Z]/.test(passwordInput.value);
    var hasSpecialCharacter = /[!@#\$%\^&\*]/.test(passwordInput.value);
    if (passwordLength >= 12 && hasUpperCase && hasSpecialCharacter) {
      strength = "strong";
      submitButton.disabled = false;
      passwordStrengthError.classList.remove("visible");
    } else if (passwordLength >= 8 && (hasUpperCase || hasSpecialCharacter)) {
      strength = "medium";
      submitButton.disabled = true;
    } else {
      strength = "weak";
      submitButton.disabled = true;
    }
    passwordStatus.textContent = strength;
    passwordStrengthMeter.setAttribute("pwd-strength", strength);
  }

  passwordInput.addEventListener("input", () => {
    updatePasswordStrength();
  });

  passwordInput.addEventListener("blur", () => {
    if (strength != "strong") {
      passwordStrengthError.classList.add("visible");
    } else {
      passwordStrengthError.classList.remove("visible");
    }
  });
}

function handleRegisterForm() {
  const form = document.querySelector(
    ".page-user-register .user-register-form"
  );
  const sidebarEl = document.querySelector(".page-user-register-sidebar");

  if (!form) return;

  createTooltip();
  handleToggleCheckboxOptions("[id^='edit-field-professional-interests'] ");
  handlePostalAddress();
  handlePassword(form);

  const formGroupItems = form.querySelectorAll(".field-group-fieldset");
  const sections = [];

  formGroupItems.forEach((item) => {
    const id = item.getAttribute("id");
    const heading = item.querySelector(".fieldset-legend").innerText;
    sections.push({
      id,
      heading,
      element: item,
    });
  });

  if (sections.length > 0) {
    sections.forEach((section) => {
      const anchorLink = document.createElement("a");
      const text = section.heading.split(".");
      const html = `<span class="step-number">${text[0]}</span><span class="step-heading">${text[1]}</span>`;
      anchorLink.setAttribute("href", `#${section.id}`);
      anchorLink.innerHTML = html;

      anchorLink.addEventListener("click", (e) => {
        e.preventDefault();
        jQuery("html, body").animate(
          {
            scrollTop:
              jQuery(`.page-user-register #${section.id}`).offset().top - 150,
          },
          250,
          "linear"
        );
      });

      if (sidebarEl) sidebarEl.append(anchorLink);
      form.classList.add("is-ready");
      observer.observe(section.element);
    });
  }
}

function handleUserAccountForm() {
  const userForm = document.querySelector(".page-user-account .user-form");
  const sidebarEl = document.querySelector(".page-user-account-sidebar");

  if (!userForm) return;

  const tabs = userForm.querySelector(
    ".field-group-tabs-wrapper ul.horizontal-tabs-list"
  );

  if (tabs) {
    sidebarEl.append(tabs);
    userForm.classList.add("is-ready");
  }

  createTooltip();
  handleToggleCheckboxOptions("[id^='edit-field-professional-interests-2'] ");
  handlePostalAddress();
  handlePassword(userForm);
}

const scrollIntoViewWithOffset = (el, offset) => {
  window.scrollTo({
    behavior: "smooth",
    top:
      el.getBoundingClientRect().top -
      document.body.getBoundingClientRect().top -
      offset,
  });
};

function scrollToErrorElement() {
  const errorElement = document.querySelector(".form-item--error-message");

  if (!errorElement) return;

  if (
    errorElement.closest("#field-postal-address-xnal-0-address-ajax-wrapper")
  ) {
    errorElement.closest(
      "#field-postal-address-xnal-0-address-ajax-wrapper"
    ).style.display = "block";
    document.querySelector(".btn-enter-manually").style.display = "none";
  }

  if (errorElement) {
    scrollIntoViewWithOffset(errorElement, 200);
  }
}

window.addEventListener("load", () => {
  handleRegisterForm();
  handleUserAccountForm();
  scrollToErrorElement();
});
